import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { Socket, io } from "socket.io-client";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";


@Injectable({
  providedIn: "root",
})
export class OnlineUsersService {
  private socket: Socket;
  public onlineUsers: Subject<any> = new Subject();
  public onlineUserDataList: Subject<any> = new Subject();
  public notification$: Subject<any> = new Subject();

  constructor(private httpClient: HttpClient, private router: Router) {

  }
  


  async recentNotify(msg) {
    if (this.socket && this.socket.connected) {
      this.socket.emit("notify-people", msg);
      console.log("Recent notify emitted:", msg);
    } else {
      console.warn("Cannot emit recent notify.");
    }
  }
  
  
 async socketMedia(media){
    if (this.socket && this.socket.connected) {
      this.socket.emit("VAULT-MEDIA-PROCESS-RESPONSE", media);
      console.log("Media upload emitted:", media);
    }
 }

  
  getUsers() {
    return this.onlineUserDataList;
  }
  
  listen(eventName: string): Observable<any> {
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data) => {
        subscriber.next(data);
      });
    });
  }
  private file: File | null = null;


  isUrlValid(body: any) {
    var headers = this.get_auth_token();
    return this.httpClient.post(environment.host + "chats/tags", body, {
      ...headers,
    });
  }

  isUrlValidSave(body: any) {
    var headers = this.get_auth_token();
    return this.httpClient.post(environment.host + "chats/tags/save", body, {
      ...headers,
    }).toPromise();
  }

  get_auth_token() {
    var token = localStorage.getItem("guestToken");
    var headers = {
      Authorization: "Bearer " + token,
    };
    return { headers: headers };
  }
}
